/**
 * Hook para obtener el rol del usuario desde el token JWT
 */

import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

export const useUserRole = () => {
  const [role, setRole] = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserRole();
  }, []);

  const getUserRole = async () => {
    try {
      const session = await fetchAuthSession();
      const payload = session?.tokens?.idToken?.payload;

      if (!payload) {
        setRole(null);
        setGroups([]);
        return;
      }

      // Obtener grupos de Cognito (prioridad sobre custom:role)
      const cognitoGroups = payload['cognito:groups'] || [];

      // El rol primario es el primer grupo (por precedencia)
      const primaryRole = cognitoGroups.length > 0 ? cognitoGroups[0] : null;

      // Fallback a custom:role si no hay grupos
      const customRole = payload['custom:role'];
      const effectiveRole = primaryRole || customRole || 'COMANDA';

      console.log('[useUserRole] Role detectado:', {
        cognitoGroups,
        primaryRole,
        customRole,
        effectiveRole
      });

      setRole(effectiveRole);
      setGroups(cognitoGroups);
    } catch (error) {
      console.error('Error obteniendo rol:', error);
      setRole(null);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    role,
    groups,
    loading,
    hasRole: (allowedRoles) => allowedRoles.includes(role),
    isComanda: () => role === 'COMANDA',
    isBarra: () => role === 'BARRA',
    isStaff: () => role === 'STAFF',
    isAdmin: () => ['OWNER', 'ADMIN'].includes(role),
    canAccessComanda: () => ['OWNER', 'ADMIN', 'COMANDA', 'BARRA', 'STAFF'].includes(role),
    canAccessWaiterView: () => ['OWNER', 'ADMIN', 'STAFF'].includes(role),
    canToggleViews: () => ['OWNER', 'ADMIN'].includes(role),
    defaultView: () => {
      if (role === 'STAFF') return 'waiter';
      if (role === 'BARRA') return 'bar';
      return 'kitchen';
    }
  };
};
